"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TdpGenerator = void 0;
/**
 * @author huajiezhang@microsoft.com
 */
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const error_1 = require("../../../error");
const constants_1 = require("../../../question/constants");
const developerPortalScaffoldUtils_1 = require("../../developerPortalScaffoldUtils");
const defaultGenerator_1 = require("../defaultGenerator");
const generator_1 = require("../generator");
const templateNames_1 = require("../templates/templateNames");
/**
 * TdpGenerator is used to generate code from TDP app definition.
 */
class TdpGenerator extends defaultGenerator_1.DefaultTemplateGenerator {
    componentName = "tdp-generator";
    // Templates that must be handled by their own specialized generators.
    // TdpGenerator must not intercept these even in TDP flow.
    static specialGeneratorTemplates = new Set([
        // CombinedProjectGenerator: splits into GraphConnector + DeclarativeAgentBasic sub-templates
        templateNames_1.TemplateNames.DeclarativeAgentWithGraphConnector,
        // DeclarativeAgentGenerator: has special post() for TypeSpec, MCP, existing action, etc.
        templateNames_1.TemplateNames.DeclarativeAgentBasic,
        templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratch,
        templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchBearer,
        templateNames_1.TemplateNames.DeclarativeAgentWithActionFromScratchOAuth,
        templateNames_1.TemplateNames.DeclarativeAgentWithExistingAction,
        templateNames_1.TemplateNames.DeclarativeAgentWithTypeSpec,
        templateNames_1.TemplateNames.DeclarativeAgentWithActionFromMCP,
        // DeclarativeAgentWithExistingApiSpecGenerator: parses API spec
        templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        // CustomEngineAgentWithExistingApiSpecGenerator: parses API spec
        templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        // OfficeAddinGeneratorNew
        templateNames_1.TemplateNames.DeclarativeAgentMetaOSNewProject,
    ]);
    // activation condition
    activate(context, inputs) {
        // TdpGenerator handles simple templates that exist directly in the zip.
        // Templates that require specialized generators (special post-processing,
        // multi-template scaffolding, API spec parsing, etc.) must not be intercepted here.
        return (inputs.teamsAppFromTdp !== undefined &&
            !TdpGenerator.specialGeneratorTemplates.has(inputs[constants_1.QuestionNames.TemplateName]));
    }
    async getTemplateInfos(context, inputs, destinationPath, actionContext) {
        const templateName = inputs[constants_1.QuestionNames.TemplateName];
        if (!templateName) {
            return (0, teamsfx_api_1.err)(new error_1.InputValidationError("teamsAppFromTdp", "Invalid App Definition", "TdpGenerator"));
        }
        const appName = inputs[constants_1.QuestionNames.AppName];
        const safeProjectNameFromVS = inputs[constants_1.QuestionNames.SafeProjectName];
        const solutionNameFromVS = inputs[constants_1.QuestionNames.SolutionName];
        const isNet8 = !inputs.targetFramework || inputs.targetFramework === "net8.0"; // used by SSR Tab
        const language = inputs[constants_1.QuestionNames.ProgrammingLanguage];
        return Promise.resolve((0, teamsfx_api_1.ok)([
            {
                templateName: templateName,
                language: language,
                replaceMap: {
                    ...generator_1.Generator.getDefaultVariables(appName, safeProjectNameFromVS, solutionNameFromVS, inputs.targetFramework, inputs.placeProjectFileInSolutionDir === "true"),
                    IsNet8Framework: isNet8 ? "true" : "",
                },
            },
        ]));
    }
    async post(context, inputs, destinationPath, actionContext) {
        const res = await developerPortalScaffoldUtils_1.developerPortalScaffoldUtils.updateFilesForTdp(context, inputs.teamsAppFromTdp, inputs);
        if (res.isErr()) {
            return (0, teamsfx_api_1.err)(res.error);
        }
        return (0, teamsfx_api_1.ok)({});
    }
}
exports.TdpGenerator = TdpGenerator;
//# sourceMappingURL=tdpGenerator.js.map